// Module
var code = `<div class="report-filters filters">
  <div class="labelled-field">
    <label for="calendar-year">Year</label>
    <input id="calendar-year"
           type="number"
           ng-model="\$ctrl.year"
           step="1"
           min="1970">
  </div>
  <div class="labelled-field">
    <button ng-click="\$ctrl.getHolidays()" class="btn btn-primary btn--filter">
      Show
    </button>
  </div>
</div>
<table class="table table--generate-row-ids table--last-column-to-right">
  <thead>
  <tr>
    <th>No.</th>
    <th>Name</th>
    <th>Date</th>
    <th command-access="DeleteBankHoliday,CreateBankHoliday">Actions</th>
  </tr>
  <tr ng-form="\$ctrl.addHolidayForm" command-access="CreateBankHoliday">
    <th>0.</th>
    <th><input ng-model="\$ctrl.name" ng-required="true"/></th>
    <th>
      <date output-format="local-date"
            ng-required="true"
            max="'9999-12-31'"
            ng-model="\$ctrl.date">
      </date>
    </th>
    <th command-access="CreateBankHoliday">
      <div class="summary-actions">
        <button type="button"
                class="btn btn-primary"
                command-access="CreateBankHoliday"
                ng-click="\$ctrl.createBankHoliday()"
                ng-disabled="\$ctrl.addHolidayForm.\$invalid">
          Add
        </button>
      </div>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="holiday in \$ctrl.holidays">
    <td></td>
    <td>{{ holiday.name }}</td>
    <td>{{ holiday.date }}</td>
    <td command-access="DeleteBankHoliday">
      <div class="summary-actions">
        <button type="button"
                class="btn btn-danger"
                command-access="DeleteBankHoliday"
                ng-click="\$ctrl.deleteHoliday(holiday)">
          Remove
        </button>
      </div>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/holiday/bank-holidays.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;